import { GiveKudosLauncher } from '@atlaskit/give-kudos';
import React, { useState } from 'react';

import { getConfig } from '@townsquare/config';
import { useFlagActions } from '@townsquare/flags';
import { useWorkspaceStore } from '@townsquare/workspace-store';

interface useKudosLauncherProps {
	analyticsSource?: string;
}
const config = getConfig();

export const useKudosLauncher = (props: useKudosLauncherProps) => {
	const [isGiveKudosOpen, setIsGiveKudosOpen] = useState(false);
	const { addFlag } = useFlagActions();
	const [workspace] = useWorkspaceStore();
	const openKudosLauncher = () => {
		setIsGiveKudosOpen(true);
	};

	const kudosLauncher = (
		<GiveKudosLauncher
			isOpen={isGiveKudosOpen}
			onClose={() => setIsGiveKudosOpen(false)}
			analyticsSource={props.analyticsSource || 'atlas'}
			teamCentralBaseUrl={config.fullUrl}
			cloudId={workspace.cloudId || ''}
			addFlag={addFlag}
		/>
	);

	return {
		openKudosLauncher,
		kudosLauncher,
	};
};
